import {ConfigurationModel} from '../models/configuration.model';
import {CustomerModel} from '../models/customer.model';
import { Injectable } from "@angular/core";

@Injectable()
export class ConfigurationDefault {
    public configuration: ConfigurationModel = {
        host: 'localhost',
        port: 9090,
        primaryAddress: 'localhost',
        secondaryAddress: 'localhost',
        gpsTimeout: 5000,
        selectedOperator: 1,
        selectedDepot: 1,
        selectedEngineer: 1,
        selectedCashAccount: null,
        selectedPrinter: null,
        printerCopies: 0,
        PODOnly: false,
        databaseVersion: 2,
        apikey: 'mobile',
        custDateTime: '1899-01-01-00-00-00-000',
        contactDateTime: '1899-01-01-00-00-00-000',
        equipmentDateTime: '1899-01-01-00-00-00-000',
        productDateTime: '1899-01-01-00-00-00-000',
        siteDateTime: '1899-01-01-00-00-00-000',
        contractDateTime: '1899-01-01-00-00-00-000',
        haccessDateTime: '1899-01-01-00-00-00-000',
        saccessDateTime: '1899-01-01-00-00-00-000',
        hratesDateTime: '1899-01-01-00-00-00-000',
        priceListDetailsDateTime: '1899-01-01-00-00-00-000',
        ptSerialDateTime: '1899-01-01-00-00-00-000',
        productBarcodeDateTime: '1899-01-01-00-00-00-000',
        automaticUploadDockets: false,
        selectedScannerFormats: [],
        barcodeTorchEnabled : false,
        selectedBarcodeDevice: null,
        standardContractTime: '08:00',
        standardReturnTime: '17:00',
        daysOfCompletedActions: 5,
        showActionsTab: false,
        showJobHoursComponent: true,
        suggestAddTransportFee: true,
        startEquipSelectedFromAllItems: false,
        offLineMode: false,
        wifiOnlyMode: false,
        podOnly: false,
        chargeDeliveryAndCollection: false,
        queuedDocumentsInMainScreen: false,
        counterSigningMode: false,
        lastMattressScanned: null,
        currentCustomer: null,
        showCustomerSigComponent: true
    };
}
